import React from 'react'
import {AnimatePresence} from 'framer-motion'
import { Route, Routes } from 'react-router-dom'
import Layout from './Layout'
import Home from '../Pages/homePage/Home'
import CategoryDetails from '../Pages/categories/DetailPage'
import CategoryListPage from '../Pages/categories/ListPage'
import ProductDetailPage from '../Pages/products/DetailPage'
import ContactUs from '../Pages/cmsPage/ContactUs'
import AboutUs from '../Pages/cmsPage/AboutUs'
import EnquiryForm from '../Pages/cmsPage/EnquiryForm'
import ListPage from '../Pages/products/ListPage'
import TermsofServices from '../Pages/cmsPage/TermsofServices'
import PrivacyPolicy from '../Pages/cmsPage/PrivacyPolicy'
import RefundPolicy from '../Pages/cmsPage/RefundPolicy'


const AnimatedRoutes = () => {
  return (
    <>
    
      <AnimatePresence mode='wait'>
        <Routes>
            <Route path='/' element={<Layout/>}>
                <Route path='/' element={<Home/>} />
            <Route path="/categories" element={<CategoryListPage />} />
            <Route path="/categories/:slug" element={<CategoryDetails />} />
                      <Route path="shop/:slug" element={<ProductDetailPage />} />

          <Route path="contact-us" element={<ContactUs />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path='/bulk-enquiry' element={<EnquiryForm/>} />
          <Route path='/shop' element={<ListPage/> } />
          <Route path='/terms-and-conditions' element={<TermsofServices/> } />
          <Route path='/privacy-policy' element={<PrivacyPolicy/> } />
          <Route path='/return-and-refund-policy' element={<RefundPolicy/> } />




            </Route>
        </Routes>
      </AnimatePresence>
    </>
  )
}

export default AnimatedRoutes
